/**
 * Calculate column widths for Excel export based on content
 * @param arrayOfObjects - Array of objects to be exported to Excel
 * @returns Array of column width objects for xlsx
 */
export function fitToColumn(arrayOfObjects: any[]): { wch: number }[] {
  if (arrayOfObjects.length === 0) return [];
  
  // Get column headers
  const headers = Object.keys(arrayOfObjects[0]);
  
  // Calculate max width for each column
  return headers.map(header => {
    // Start with header width
    let maxWidth = header.length;
    
    // Check all data rows
    arrayOfObjects.forEach(row => {
      const cellValue = String(row[header] || '');
      maxWidth = Math.max(maxWidth, cellValue.length);
    });
    
    // Add some padding and set a reasonable max width
    return { wch: Math.min(maxWidth + 2, 50) };
  });
}
